export default __webpack_public_path__ + "static/media/ea_accountabilities.bf70b70e.png";